import { render, staticRenderFns } from "./HomeBidDia.vue?vue&type=template&id=2f2c97f0&scoped=true&"
import script from "./HomeBidDia.vue?vue&type=script&lang=ts&"
export * from "./HomeBidDia.vue?vue&type=script&lang=ts&"
import style0 from "./HomeBidDia.vue?vue&type=style&index=0&id=2f2c97f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2c97f0",
  null
  
)

export default component.exports